import { render, staticRenderFns } from "./BoottomTab.vue?vue&type=template&id=e307e888&scoped=true"
import script from "./BoottomTab.vue?vue&type=script&lang=js"
export * from "./BoottomTab.vue?vue&type=script&lang=js"
import style0 from "./BoottomTab.vue?vue&type=style&index=0&id=e307e888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e307e888",
  null
  
)

export default component.exports